import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ListStudenteGraficoDTO } from 'src/app/model/newModel';
import { ConstantsCLA } from 'src/app/shared/constants-cla';
import { GetCommand } from '../../../model/command-model';

@Injectable({
  providedIn: 'root',
})
export class StatisticheService {
  constructor(private http: HttpClient) {}


  getStatistiche(idSessioneOla: number) {
    const command = new GetCommand();
    command.id = idSessioneOla;
    return this.http.post<ListStudenteGraficoDTO>(
      ConstantsCLA.STATISTICHE_URL,
      command
    );
  }

  getStatisticheExcel(idSessioneOla: number) {
    const httpOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({}),
    };

    const command = new GetCommand();
    command.id = idSessioneOla;

    return this.http.post<any>(
      ConstantsCLA.STATISTICHE_EXCEL_URL,
      command,
      httpOptions
    );
  }
}
